module.exports = "#ifdef USE_THEMING\n#ifdef EVAL_THEMING_VIZFLAGS_IN_SHADER\nout vec4 themingColor;\n#endif\n#endif\n";